import { z } from 'zod';

export const activityNotificationGenerationRequestSchema = z.object({
  prompt: z.string().describe('Prompt or context for notification generation'),
  tone: z
    .enum(['friendly', 'formal', 'urgent', 'motivational', 'reminder'])
    .optional()
    .describe('Tone of the notification'),
  currentMessage: z.string().optional().describe('Current message to improve or use as reference'),
  additionalRequirements: z
    .string()
    .optional()
    .describe('Additional requirements for the notification'),
  language: z.string().default('es').describe('Language for generation'),
});

export const activityNotificationSchema = z.object({
  message: z.string().describe('Generated notification message with activity variables'),
});

export type ActivityNotificationGenerationRequest = z.infer<
  typeof activityNotificationGenerationRequestSchema
>;
export type ActivityNotification = z.infer<typeof activityNotificationSchema>;
